import {
  Bot,
  ClipboardPlus,
  FileText,
  Mail,
  ScanLine,
  Stethoscope,
} from "lucide-react"

import type { SuggestionCard } from "@/types"

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  bot: Bot,
  mail: Mail,
  "clipboard-plus": ClipboardPlus,
  "scan-line": ScanLine,
  "file-text": FileText,
  stethoscope: Stethoscope,
}

interface SuggestionCardsProps {
  cards: SuggestionCard[]
  onSelect: (card: SuggestionCard) => void
}

export function SuggestionCards({ cards, onSelect }: SuggestionCardsProps) {
  if (cards.length === 0) return null

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {cards.map((card) => {
        const Icon = iconMap[card.icon] ?? Bot
        return (
          <button
            key={card.title}
            type="button"
            onClick={() => onSelect(card)}
            className="bg-background hover:bg-muted/50 flex flex-col justify-between rounded-xl border p-4 text-left transition-colors"
          >
            <span className="text-sm">{card.title}</span>
            <Icon className="text-muted-foreground mt-6 size-5" />
          </button>
        )
      })}
    </div>
  )
}
